// The same pattern zod 3 applies to .email(), so the form and server agree.
const EMAIL = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9-]*\.)+[A-Z]{2,}$/i;
const PHONE_CHARS = /^\+?[\d\s().-]+$/;
const US_PHONE_DIGITS = 10;
const DEAL_VALUE = /^\d+(\.\d{1,2})?$/;

export function isValidEmail(value: string): boolean {
  return EMAIL.test(value.trim());
}

/** A US number in any common layout: 5551234567, 555-123-4567, (555) 123-4567,
 *  555.123.4567, +1 555 123 4567. */
export function isValidUsPhone(value: string): boolean {
  const text = value.trim();
  if (!PHONE_CHARS.test(text)) return false;
  const digits = text.replace(/\D/g, '');
  if (digits.length === US_PHONE_DIGITS + 1) return digits.startsWith('1');
  return digits.length === US_PHONE_DIGITS && !text.startsWith('+');
}

/** Cents from what was typed: "2400", "2,400" and "$2,400.50" all parse. Blank
 *  is `null` (no deal value); anything else unreadable is `undefined`. */
export function parseDealValueCents(text: string): number | null | undefined {
  const cleaned = text.trim().replace(/^\$/, '').replace(/,/g, '');
  if (cleaned === '') return null;
  if (!DEAL_VALUE.test(cleaned)) return undefined;
  return Math.round(Number(cleaned) * 100);
}
